import axios from 'axios';
import { API_URL } from '../../lib/const';

export const fetchTemplates = (params) =>
  axios
    .get(`${API_URL}/contracts/contract_template`, {
      params,
    })
    .then((response) => response.data);

export const fetchTemplateDetails = (id) =>
  axios
    .get(`${API_URL}/contracts/contract_template/${id}`)
    .then((response) => response.data);

export const fetchDynamicTemplateFields = (params) =>
  axios
    .get(`${API_URL}/contracts/contract_field`, {
      params,
    })
    .then((response) => response.data);

export const updateTemplate = (id, data = {}) =>
  axios
    .patch(`${API_URL}/contracts/contract_template/${id}`, data)
    .then((response) => response.data)
    .catch((err) => {
      throw 'Erro ao atualizar, cheque se as informações estão presentes.';}
    );;

export const createTemplate = (data = {}) =>
  axios
    .post(`${API_URL}/contracts/contract_template`, data)
    .then((response) => response.data)
    .catch((err) => {
      throw 'Erro: Certifique de que todas as informações foram preenchidas.'}
    );

export const duplicateTemplate = (id, newTitle) =>
  axios
    .post(`${API_URL}/contracts/contract_template/${id}/duplicate`, {
      new_template_title: newTitle})
    .then((response) => response.data)
    .catch((err) => {
      throw 'Ocorreu um erro ao duplicar.';}
    );
